import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { GridColDef } from '@mui/x-data-grid';
import { GridActionsCell } from '@mui/x-data-grid';
import { defaultDashValueGetter } from '@cbridge-utils/formatters';
import { OpenLinkButton } from '@cbridge-tools/button';
import { IStreamServer } from '@cbridge-packages/stream';
import { SERVER_TYPE_LABEL_KEY } from '@cbridge-packages/server';
import { generateTradingServerRoute } from '@cbridge-packages/routing-client-admin';

export const useConnectedServersColDef: () => GridColDef<IStreamServer>[] = () => {
  const { t } = useTranslation();

  const columns: GridColDef<IStreamServer>[] = useMemo(() => [
    {
      field: 'name',
      headerName: t('text:entity.markupStream.server.label'),
      flex: 1,
    },
    {
      field: 'type',
      headerName: t('text:entity.markupStream.serverType.label'),
      valueGetter: (value: IStreamServer['type']) => t(SERVER_TYPE_LABEL_KEY[value]),
      flex: 1,
    },
    {
      field: 'tradingClient',
      headerName: t('text:entity.markupStream.serverConnection.label'),
      valueGetter: (value: IStreamServer['tradingClient']) => value?.enabled,
      flex: 1,
      type: 'boolean',
    },
    {
      field: 'throttlingInterval',
      headerName: `${t('text:common.field.throttlingInterval.label')}, ${t('text:common.unit.ms')}`,
      valueGetter: defaultDashValueGetter,
      flex: 1,
    },
    {
      field: 'actions',
      hideable: false,
      resizable: false,
      sortable: false,
      type: 'actions',
      width: 30,
      renderCell: (params) => (
        <GridActionsCell {...params} suppressChildrenValidation={true}>
          <OpenLinkButton href={generateTradingServerRoute(params.row.serverId)} />
        </GridActionsCell>
      ),
    },
  ], [t]);

  return columns;
};
